"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchoolDeactivateDto = void 0;
const class_validator_1 = require("class-validator");
const school_deactivation_reason_enum_1 = require("../../enums/school-deactivation-reason.enum");
class SchoolDeactivateDto {
    deactivationReason;
}
exports.SchoolDeactivateDto = SchoolDeactivateDto;
__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsEnum)(school_deactivation_reason_enum_1.SchoolDeactivationReasonEnum, {
        message: 'Deactivation reason is invalid'
    }),
    __metadata("design:type", String)
], SchoolDeactivateDto.prototype, "deactivationReason", void 0);
